import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

export type CPPersonalInfoFormLoc =
	| 'CPPersonalInfoFormDOBLabel'
	| 'CPPersonalInfoFormDOBErrorReq'
	| 'CPPersonalInfoFormDOBErrorMax'
	| 'CPPersonalInfoFormFirstNameQuestionMark'
	| 'CPPersonalInfoFormLastNameQuestionMark';

export const cpPersonalInfoFormLocs: LocDefs<CPPersonalInfoFormLoc> = {
	CPPersonalInfoFormDOBLabel: {
		defaultValue: 'Date of Birth',
		description: 'Label for the candidate Date of Birth Field',
		displayPath: 'Profile|Information|Date of Birth|Label',
		displayType: 'Label',
		shared: true,
		portal: 'CP',
		feature: HubFeature.CandidateProfileDateOfBirth,
	},
	CPPersonalInfoFormDOBErrorReq: {
		defaultValue: 'Date of Birth is required',
		description: 'Error displayed when candidate date of birth is not supplied',
		displayPath: 'Profile|Information|Date of Birth|Required Error',
		displayType: 'Error',
		shared: true,
		portal: 'CP',
		feature: HubFeature.CandidateProfileDateOfBirth,
	},
	CPPersonalInfoFormDOBErrorMax: {
		defaultValue: 'Date of Birth must be before today',
		description: 'Error displayed when candidate date of birth is in the future',
		displayPath: 'Profile|Information|Date of Birth|Future Error',
		displayType: 'Error',
		shared: true,
		portal: 'CP',
		feature: HubFeature.CandidateProfileDateOfBirth,
	},
	CPPersonalInfoFormFirstNameQuestionMark: {
		defaultValue: 'First name must not contain only question marks',
		description: 'Error displayed when there are only question marks in the field',
		displayPath: 'Profile|Information|First Name|Question Marks',
		displayType: 'Error',
		shared: true,
		portal: 'CP',
		feature: HubFeature.CandidateAccess,
	},
	CPPersonalInfoFormLastNameQuestionMark: {
		defaultValue: 'Last name must not contain only question marks',
		description: 'Error displayed when there are only question marks in the field',
		displayPath: 'Profile|Information|Last Name|Question Marks',
		displayType: 'Error',
		shared: true,
		portal: 'CP',
		feature: HubFeature.CandidateAccess,
	},
};

export const LOC_KEYS = MapLocKeys<CPPersonalInfoFormLoc>(cpPersonalInfoFormLocs);
export type CPPersonalInfoFormLocType = LocMap<CPPersonalInfoFormLoc>;
